import { Component, Input, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Curso } from "src/app/services/curso.service";
import Swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PipeRunService } from "src/app/services/piperun.service";

@Component({
  selector: "app-curso-layout",
  templateUrl: "./curso-layout.component.html",
})
export class CursoLayoutComponent implements OnInit {
  @Input() public curso: Curso | any;

  public leadForm!: FormGroup;

  constructor(
    private location: Location,
    private pipeRunService: PipeRunService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.buildLeadForm();
  }

  public buildLeadForm() {
    this.leadForm = this.fb.group({
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      mobile: [null, Validators.required],
    });
  }

  public async onSubmit() {
    const emailControl = this.leadForm.get("email");

    if (emailControl?.invalid) {
      if (emailControl.errors?.["email"]) {
        Swal.fire({
          title: "Atenção",
          text: "Por favor, insira um e-mail válido.",
          icon: "warning",
          customClass: {
            confirmButton: "swal2-confirm-style",
          },
        });
        return;
      }
    }

    if (this.leadForm.invalid) {
      Swal.fire({
        title: "Atenção",
        text: "Por favor, preencha todos os campos.",
        icon: "warning",
        customClass: {
          confirmButton: "swal2-confirm-style",
        },
      });
      return;
    }

    const form = this.leadForm.value;

    const params = {
      name: form.name,
      email: form.email,
      mobile: form.mobile,
      curso: this.curso.nome,
    };

    this.pipeRunService.create(params).subscribe({
      next: () => {
        Swal.fire({
          title: "Sucesso",
          text: "Recebemos seus dados. Nossa equipe entrará em contato com você em breve.",
          icon: "success",
          customClass: {
            confirmButton: "swal2-confirm-style",
          },
        });
        this.leadForm.reset();
      },
      error: () => {
        Swal.fire({
          title: "Erro",
          text: "Algo deu errado. Tente novamente ou entre em contato com o suporte",
          icon: "error",
          customClass: {
            confirmButton: "swal2-confirm-style",
          },
        });
      },
    });
  }

  public formatCurrency(value: number) {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  public calcularDesconto(precoOriginal: number, precoAtual: number): number {
    if (!precoOriginal || precoOriginal <= precoAtual) return 0;
    const desconto = ((precoOriginal - precoAtual) / precoOriginal) * 100;
    return Math.round(desconto);
  }

  public share(platform: string) {
    const baseUrl = window.location.origin;

    const currentPath = this.location.path();

    const fullUrl = `${baseUrl}${currentPath}`;

    let shareUrl = "";

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
          fullUrl
        )}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/share?url=${encodeURIComponent(
          fullUrl
        )}&text=${encodeURIComponent(document.title)}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/cws/share?url=${encodeURIComponent(
          fullUrl
        )}`;
        break;
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodeURIComponent(fullUrl)}`;
        break;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }
  }

  public onEmailInput(event: any) {
    const input = event.target;
    input.value = input.value.toLowerCase();
  }
}
